export default "__VITE_ASSET__eP7kVMMz__"